module.exports = __webpack_public_path__ + "assets/img/rule-befor-icon.3f92cf25.png";